export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=705bc5951cadacd2304c2b74d85e8052cd6d07effb&name=pushAdClickData!'